export default __webpack_public_path__ + "static/media/salchicha_italiana.632bcd52.jpeg";